import { DEFAULT_TIME_ZONE_ID } from './LegalAgreement';

/** The US zones a new campaign can start in, named the way people say them. */
export const US_TIME_ZONES = [
  { id: 'America/New_York', label: 'Eastern (New York, Florida, Georgia…)' },
  { id: 'America/Chicago', label: 'Central (Alabama, Texas, Illinois…)' },
  { id: 'America/Denver', label: 'Mountain (Colorado, Utah, New Mexico…)' },
  { id: 'America/Phoenix', label: 'Arizona (no daylight saving)' },
  { id: 'America/Los_Angeles', label: 'Pacific (California, Washington, Nevada…)' },
  { id: 'America/Anchorage', label: 'Alaska' },
  { id: 'Pacific/Honolulu', label: 'Hawaii' },
] as const;

function utcOffset(timeZone: string, at: Date): string | undefined {
  return new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'longOffset' })
    .formatToParts(at)
    .find((part) => part.type === 'timeZoneName')?.value;
}

/**
 * The listed zone this browser keeps the same clock as, winter and summer, so Detroit reads as Eastern and
 * Boise as Mountain. Eastern when the browser is outside the US or its zone can't be read.
 */
export function browserUsTimeZone(): string {
  try {
    const browser = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const year = new Date().getUTCFullYear();
    const seasons = [new Date(Date.UTC(year, 0, 15)), new Date(Date.UTC(year, 6, 15))];
    const clock = (zone: string) => seasons.map((at) => utcOffset(zone, at)).join();
    const match =
      US_TIME_ZONES.find((zone) => zone.id === browser) ??
      US_TIME_ZONES.find((zone) => clock(zone.id) === clock(browser));
    return match?.id ?? DEFAULT_TIME_ZONE_ID;
  } catch {
    return DEFAULT_TIME_ZONE_ID;
  }
}
